<template>
    <div class="card border-0 rounded-0 bg-white letter-spacing chat-card">
        <div
            class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-flex align-items-center">
                <div class="ms-15">
                    <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium">
                        {{ $t('feature.$messages.select_patient_message')}} 
                    </span>
                </div>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 d-felx flex-column">
            <div class="chat-list flex-grow-1">
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "MessagesEmpty",
});
</script>